(function () {
  function setHeaderOffset() {
    var announcementSection = document.querySelector('.shopify-section:has(animated-background-text-colors)');
    var announcement = document.querySelector('animated-background-text-colors');
    var headerWrapper = document.querySelector('.header-section--wrapper');

    var announcementH = 0;
    if (announcementSection) {
      announcementH = announcementSection.getBoundingClientRect().height;
    } else if (announcement) {
      announcementH = announcement.getBoundingClientRect().height;
    }
    if (announcementH < 1) announcementH = 40;

    var headerH = headerWrapper ? headerWrapper.getBoundingClientRect().height : 80;

    document.documentElement.style.setProperty('--announcement-height', announcementH + 'px');
    document.documentElement.style.setProperty('--header-height', (announcementH + headerH) + 'px');
  }

  function lockHeaderBg() {
    var headerEl = document.querySelector('.header-section--wrapper');
    if (!headerEl) return;
    var isIndex = document.body.classList.contains('template-index');
    if (isIndex) return;
    if (document.body.classList.contains('sc-about-page')) return;
    headerEl.style.setProperty('background-color', 'rgba(255,255,255,0.97)', 'important');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setHeaderOffset();
      var headerEl = document.querySelector('.header-section--wrapper');
      if (headerEl) {
        headerEl.addEventListener('mouseenter', lockHeaderBg);
        headerEl.addEventListener('mouseleave', lockHeaderBg);
      }
      lockHeaderBg();
    });
  } else {
    setHeaderOffset();
    var headerEl = document.querySelector('.header-section--wrapper');
    if (headerEl) {
      headerEl.addEventListener('mouseenter', lockHeaderBg);
      headerEl.addEventListener('mouseleave', lockHeaderBg);
    }
    lockHeaderBg();
  }
  window.addEventListener('resize', setHeaderOffset);
  window.addEventListener('load', function () {
    setHeaderOffset();
    lockHeaderBg();
  });
})();

/* === Attribution passthrough ===
   Carries the tracking params a visitor arrived with onto internal links marked
   with [data-sc-keep-utm] (the mobile Shop pill). Params are stashed in
   sessionStorage so they survive internal navigation — a visitor can land on /,
   browse to /pages/about, then tap Shop and still keep attribution. */
(function () {
  var STORAGE_KEY = 'sc:tracking-params';

  // utm_* is matched by prefix; these are the click IDs the ad platforms append.
  var CLICK_IDS = [
    'gclid', 'gbraid', 'wbraid', 'dclid',
    'fbclid', 'ttclid', 'msclkid', 'twclid',
    'epik', 'irclickid', 'li_fat_id', 'rdt_cid', 'sccid'
  ];

  function isTrackingKey(key) {
    var lower = key.toLowerCase();
    return lower.indexOf('utm_') === 0 || CLICK_IDS.indexOf(lower) !== -1;
  }

  function readStored() {
    try {
      var raw = window.sessionStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : null;
      return parsed && typeof parsed === 'object' ? parsed : {};
    } catch (e) {
      // Private mode / storage disabled — fall back to URL-only behaviour.
      return {};
    }
  }

  function store(params) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    } catch (e) {}
  }

  // A fresh set of params on the URL replaces the stored set outright, so a new
  // campaign click never inherits leftovers from the previous one.
  function resolveParams() {
    if (!window.URLSearchParams) return {};

    var found = {};
    var hasAny = false;
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (value && isTrackingKey(key)) {
        found[key] = value;
        hasAny = true;
      }
    });

    if (hasAny) {
      store(found);
      return found;
    }
    return readStored();
  }

  function decorate(link, params) {
    var href = link.getAttribute('href');
    if (!href) return;

    var url;
    try {
      url = new URL(href, window.location.origin);
    } catch (e) {
      return;
    }

    // Only touch same-origin links, and never clobber a param already on the href.
    if (url.origin !== window.location.origin) return;
    Object.keys(params).forEach(function (key) {
      if (!url.searchParams.has(key)) url.searchParams.set(key, params[key]);
    });

    link.setAttribute('href', url.pathname + url.search + url.hash);
  }

  function init() {
    var params = resolveParams();
    if (!Object.keys(params).length) return;

    var links = document.querySelectorAll('a[data-sc-keep-utm]');
    for (var i = 0; i < links.length; i++) decorate(links[i], params);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
